import React from "react";
import { Container, Col, Row, Form, FormGroup, Input, Button} from "reactstrap";

import General from "./data/General"

class YourView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      text: "",
      feedback:false
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    const scriptURL =
      // `https://script.google.com/macros/s/AKfycbxZwH7Nr5z0BQoQXv2CMUa62djTmcq-wSqszSQglLiwBJA0IGUF/exec?data1=${this.state.text}`;
          // https://script.google.com/macros/s/AKfycbxZwH7Nr5z0BQoQXv2CMUa62djTmcq-wSqszSQglLiwBJA0IGUF/exec
      `https://script.google.com/macros/s/AKfycbxCPf3ku4nmtQTVbXg1Y46vFganHdbHDbeejJEk6woRpK93MEHW/exec?data1=${this.state.text}`;

    if (this.state.text!==""){
      this.setState({
        feedback: true
      });
    fetch(scriptURL)
      .then(response => console.log("Success!", response))
      .catch(error => console.error("Error!", error.message));
    }
  };

  handleChange = e => {
    this.setState({
      text: e.target.value
    });
  };

  render() {
    let feedback=this.state.feedback?<p className="whiteback text-right feedbackpad">  شكرا على المشاركة تابعنا <a href="https://twitter.com/AJLabs" target="_blank">على لمزيد</a> من المعلومات</p>:<p>&nbsp;</p>

    // let options = this.state.cities.map(function (city) {
    //         return city.name;
    // })
    return (
      <div className="fullscreen yourview">
        <Container fluid className="fullscreen">
          <Row className="justify-content-center align-items-center">
            <Col xl="5" lg="6" md="8" xs="10" className="text-left">
              <h2 className="display-3 text-center font-weight-bold white blackbox">
                {General[4].chapterAR}
              </h2>
              <Form style={{display:this.state.feedback?"none":"block"}} onSubmit={this.handleSubmit} name="googlesheet">
                <FormGroup>
                <Input style={{height:"150px"}}
                    type="textarea"
                    value={this.state.text}
                    onChange={this.handleChange}
                  />
                  <br/>
                  <Button size="lg" type="submit" style={{display:this.state.feedback?"none":"block"}} className="text-center">
                  شارك
                  </Button>
                </FormGroup>
              </Form>
              {feedback}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default YourView;